import { render, staticRenderFns } from "./OdnoklassnikiButton.vue?vue&type=template&id=de2519ac&scoped=true&"
import script from "./OdnoklassnikiButton.vue?vue&type=script&lang=js&"
export * from "./OdnoklassnikiButton.vue?vue&type=script&lang=js&"
import style0 from "./OdnoklassnikiButton.vue?vue&type=style&index=0&id=de2519ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2519ac",
  null
  
)

export default component.exports